import { useEffect, useState } from 'react';
import { useConnect, useAccount, useDisconnect, useSwitchChain } from 'wagmi';
import { getNetworksByWalletName, isEVMChain, resolveEvmConnector, WEB3_ADDRESS, } from '../../wallet';
import { ConnectionState } from '../../wallet/types';
import { DEFAULT_WALLET_CONNECTION } from '../constants';
import { translateErrorMessage } from '../../utils/common';
import { checkEVMChainExists } from '../utils/chain-state';
export function useEvmConnection({ walletConnection, setWalletConnection, toast, setIsWalletModalOpen, }) {
    const { connectors } = useConnect();
    const { address: evmAddress, chain: curEvmChain, connector: curEVMConnector, isConnected, status: evmStatus, } = useAccount();
    const { disconnect: wagmiDisconnect } = useDisconnect();
    const { switchChain } = useSwitchChain();
    const [newEvmConnector, setNewEvmConnector] = useState(null);
    useEffect(() => {
        if (walletConnection.connectionState === ConnectionState.Connecting &&
            walletConnection.network &&
            walletConnection.wallet &&
            isEVMChain(walletConnection.network) &&
            newEvmConnector) {
            if (getNetworksByWalletName(walletConnection.wallet).includes(walletConnection.network, 0)) {
                newEvmConnector
                    .connect({ chainId: WEB3_ADDRESS[walletConnection.network].chainId })
                    .catch((error) => {
                    if (!error.message.includes('rejected')) {
                        toast.error(`Failed to connect to ${walletConnection.network} with ${walletConnection.wallet}: ${error.message}`);
                    }
                    setNewEvmConnector(null);
                    setWalletConnection(DEFAULT_WALLET_CONNECTION);
                });
            }
            else {
                toast.error('This chain is not supported by the wallet you selected.');
                setWalletConnection(DEFAULT_WALLET_CONNECTION);
            }
        }
    }, [newEvmConnector, walletConnection]);
    useEffect(() => {
        if (!curEVMConnector ||
            !evmAddress ||
            !curEvmChain ||
            !isConnected ||
            walletConnection.connectionState === ConnectionState.Disconnecting) {
            return;
        }
        const isUserInitiatedConnect = walletConnection.connectionState === ConnectionState.Connecting ||
            (!walletConnection.network &&
                !walletConnection.wallet &&
                walletConnection.connectionState === ConnectionState.Disconnected);
        if (!isUserInitiatedConnect)
            return;
        let newInfo = {};
        if (!walletConnection.network &&
            !walletConnection.wallet &&
            walletConnection.connectionState === ConnectionState.Disconnected) {
            newInfo = { wallet: curEVMConnector.name, network: checkEVMChainExists(curEvmChain.name) };
        }
        setWalletConnection({
            ...walletConnection,
            ...newInfo,
            connectionState: ConnectionState.Connected,
            address: evmAddress.toString(),
        });
        setIsWalletModalOpen(false);
    }, [evmAddress, curEvmChain, walletConnection, curEVMConnector, isConnected]);
    const resolveConnectorForWallet = (walletName) => {
        return resolveEvmConnector(walletName, connectors);
    };
    const switchEvmNetwork = (network, walletConnectionSnapshot) => {
        const chainInfo = WEB3_ADDRESS[network];
        if (!chainInfo)
            return;
        switchChain({ chainId: chainInfo.chainId });
        setWalletConnection({
            ...walletConnectionSnapshot,
            network,
        });
    };
    const disconnectEvm = () => {
        wagmiDisconnect(curEVMConnector ? { connector: curEVMConnector } : {}, {
            onError: (error) => {
                toast.error(`Failed to disconnect from ${walletConnection.network} with ${walletConnection.wallet}: ${translateErrorMessage(error)}`);
            },
        });
    };
    return {
        connectors,
        evmAddress,
        curEvmChain,
        curEVMConnector,
        isConnected,
        evmStatus,
        newEvmConnector,
        setNewEvmConnector,
        resolveConnectorForWallet,
        switchEvmNetwork,
        disconnectEvm,
    };
}
